import metatags from "./metatags";

export const common = {
    metatags,
};

export default common;
